import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { formatApiErrorDetail } from "../lib/api";
import { IMAGES } from "../data/demo";

export default function Auth() {
  const { login, register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") await login(form.email, form.password);
      else await register(form.name, form.email, form.password);
      toast.success("BuyDubai.ai");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || t("common.error"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[85vh] grid md:grid-cols-2" data-testid="auth-page">
      <div className="hidden md:block relative">
        <img src={IMAGES.heroSkyline} alt="Dubai" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-ink/80" />
        <div className="absolute bottom-10 left-10 rtl:right-10 rtl:left-auto max-w-sm">
          <div className="font-display text-3xl text-white">{t("auth.side_title")}</div>
          <p className="text-white/60 mt-2 text-sm">{t("auth.side_sub")}</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-sm">
          <h1 className="font-display text-3xl text-white">{mode === "login" ? t("auth.welcome") : t("auth.create")}</h1>
          <p className="text-white/50 text-sm mt-1">{mode === "login" ? t("auth.welcome_sub") : t("auth.create_sub")}</p>

          <form onSubmit={submit} className="mt-8 space-y-3">
            {mode === "register" && (
              <input required placeholder={t("auth.name")} value={form.name} onChange={set("name")} data-testid="auth-name" className="w-full bg-input/50 border border-white/10 rounded-lg px-3 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-gold/40" />
            )}
            <input required type="email" placeholder={t("auth.email")} value={form.email} onChange={set("email")} data-testid="auth-email" className="w-full bg-input/50 border border-white/10 rounded-lg px-3 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-gold/40" />
            <input required type="password" placeholder={t("auth.password")} value={form.password} onChange={set("password")} data-testid="auth-password" className="w-full bg-input/50 border border-white/10 rounded-lg px-3 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-gold/40" />
            <button disabled={busy} type="submit" data-testid="auth-submit" className="w-full py-3 rounded-lg bg-gold text-ink font-semibold hover:brightness-110 disabled:opacity-50 transition-all duration-200">
              {busy ? t("common.loading") : mode === "login" ? t("auth.sign_in") : t("auth.sign_up")}
            </button>
          </form>

          <button onClick={() => setMode(mode === "login" ? "register" : "login")} data-testid="auth-toggle" className="mt-5 text-sm text-white/60 hover:text-gold">
            {mode === "login" ? t("auth.to_register") : t("auth.to_login")}
          </button>
        </div>
      </div>
    </div>
  );
}
